import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";
import VideoSettings from "../../VideoSettings";

const SettingsControl = ({
  settingsRef,
  isCCAvailable,
  isADAvailable,
  translate,
  settingButtonHandler,
  spinnerToggle,
  settingsDropdownVisibility,
  isClosedCaptionEnabled,
  onSubTitleChange,
  onADToggleChange,
  isDescribedVideoEnabled,
  playerMgr,
}) => {
  const theme = useTheme();
  return (
    <div ref={settingsRef} className="player-popup-container">
      {isCCAvailable || isADAvailable ? (
        <VideoPlayerButtonComponent
          src={process.env.PUBLIC_URL + "/images/gear-icon.svg"}
          alt={translate("settings")}
          onClickHandler={settingButtonHandler}
          disabled={spinnerToggle}
          $hoverBackgroundColor={theme.colours.mineShaftGray}
        />
      ) : null}
      {settingsDropdownVisibility ? (
        <VideoSettings
          closeCaption={isClosedCaptionEnabled.current}
          onCloseCaptionChange={onSubTitleChange}
          onAudioDescVideoChange={onADToggleChange}
          audioDescribeVideo={isDescribedVideoEnabled.current}
          playerMgr={playerMgr.current}
          isADEnabled={isADAvailable}
          isCCAvailable={isCCAvailable}
        />
      ) : null}
    </div>
  );
};

export default SettingsControl;
